import { notification } from "antd";
import axios from "axios";
import { handlerError } from "utils";

export const createRewardVoucher = async (rewards, idempotencyKey) => {
  try {
    const body = {
      data: [...rewards],
    };

    const headers = {
      "idempotency-key": idempotencyKey,
    };

    const resp = await axios.post(`/reward-voucher`, body, { headers });
    return resp.data;
  } catch (ex) {
    handlerError(ex);
    return [];
  }
};

export const getRewardVouchers = async (company) => {
  try {
    const res = await axios.get(`/reward-voucher`, { params: { company } });
    return res.data;
  } catch (ex) {
    handlerError(ex);
    return [];
  }
};

export const cancelRewardVouchers = async (links) => {
  try {
    const resp = await axios.delete(`/reward-voucher`, {
      data: {
        ids: links,
      },
    });
    return resp.data;
  } catch (ex) {
    notification.error({ message: "Erro ao cancelar link." });
    return false;
  }
};

export const resendRewardVoucher = async (id) => {
  try {
    await axios.post(`/reward-voucher/${id}/resend-receipt`);
    notification.success({ message: "Comprovante reenviado com sucesso." });
    return true;
  } catch (ex) {
    notification.error({ message: "Erro ao reenviar comprovante." });
    return false;
  }
};

export const resendRewardVoucherWhatsapp = async (id) => {
  try {
    notification.success({ message: "WhatsApp reenviado com sucesso." });
    return true;
  } catch (ex) {
    notification.error({ message: "Erro ao reenviar WhatsApp." });
    return false;
  }
};

export const resendVoucherNotification = async (id) => {
  try {
    await axios.post(`/reward-voucher/${id}/resend-notification`);
    notification.success({ message: "Notificação reenviada com sucesso." });
    return true;
  } catch (ex) {
    notification.error({ message: "Erro ao reenviar notificação." });
    return false;
  }
};
